import { AcessosModel } from '@/domain/models'
import { GetAccessLog } from '@/domain/usecases'
import { RemoteGetAccessLog } from '@/data/usecases'
import { makeAxiosHttpClient } from '@/main/factories/http'
import env from '@/main/config/env'

export const makeGetAccessLog = (): GetAccessLog => {
  const url = env.API_URL
  const httpClient = makeAxiosHttpClient<AcessosModel>()

  return new RemoteGetAccessLog(url, httpClient)
}
